import React, { useEffect, useRef, useState } from "react";
import { string, number } from "prop-types";

import Icon from "@components/shared/Icons/Icon";
import ReplayIcon from "@components/shared/Icons/ReplayIcon";
import YouTubeIcon from "@components/shared/Icons/YouTubeIcon";

const YouTube = ({ videoId, height, width }) => {
  const [isYouTubeVideoPause, setIsYouTubeVideoPause] = useState(false);
  const [isYouTubeVideoEnd, setIsYouTubeVideoEnd] = useState(false);

  const playerRef = useRef(null);
  const timeoutRef = useRef(null);

  const onPlayerStateChange = event => {
    clearTimeout(timeoutRef.current);

    if (event.data === window.YT.PlayerState.ENDED) {
      setIsYouTubeVideoEnd(true);
      setIsYouTubeVideoPause(false);
      playerRef.current?.pauseVideo?.();
      playerRef.current?.seekTo?.(0);

      return;
    }

    if (event.data === window.YT.PlayerState.PLAYING) {
      setIsYouTubeVideoEnd(false);
      setIsYouTubeVideoPause(false);

      return;
    }

    if (event.data === window.YT.PlayerState.PAUSED) {
      setIsYouTubeVideoEnd(false);
      setIsYouTubeVideoPause(true);
    }
  };

  const playVideo = () => {
    playerRef.current?.playVideo?.();
  };

  useEffect(() => {
    if (!window.YT) {
      const script = document.createElement("script");

      script.src = "https://www.youtube.com/iframe_api";

      document.head.appendChild(script);
    }

    const createVideoPlayer = () => {
      playerRef.current = new window.YT.Player("player", {
        frameBorder: "0",

        allow:
          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",

        events: {
          onReady: event => event.target.playVideo(),
          onStateChange: onPlayerStateChange,
        },

        playerVars: {
          controls: 0,
        },

        height,
        width,
        videoId,
      });
    };

    window.onYouTubeIframeAPIReady = createVideoPlayer;

    if (window.YT) {
      createVideoPlayer();
    }
  }, []);

  return (
    <div className="w-full max-w-160 relative">
      <div className="rounded-md w-full aspect-video" id="player" />
      {(isYouTubeVideoPause || isYouTubeVideoEnd) && (
        <div
          className="grid place-items-center absolute inset-0 bg-black cursor-pointer rounded-md group"
          onClick={playVideo}
        >
          <Icon
            className="size-20 p-4 text-white ring-2 ring-white rounded-full transition duration-150 group-hover:scale-105 group-active:scale-95"
            icon={isYouTubeVideoEnd ? <ReplayIcon /> : <YouTubeIcon />}
          />
        </div>
      )}
    </div>
  );
};

YouTube.propTypes = {
  videoId: string.isRequired,
  height: number.isRequired,
  width: number.isRequired,
};

export default YouTube;
